import { render, staticRenderFns } from "./apps.vue?vue&type=template&id=e2028266"
import script from "./apps.vue?vue&type=script&lang=js"
export * from "./apps.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/nortonpigozzo/Development/nisoftwares/VeinsEnergia-api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e2028266')) {
      api.createRecord('e2028266', component.options)
    } else {
      api.reload('e2028266', component.options)
    }
    module.hot.accept("./apps.vue?vue&type=template&id=e2028266", function () {
      api.rerender('e2028266', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/components/apps.vue"
export default component.exports